import { createContext } from 'react';

const InProgressContext = createContext();

export default InProgressContext;
